export function normalizeLvNumber(raw) {
  if (raw == null) return "";
  let digits = String(raw).replace(/[^\d]/g, "");
  if (!digits) return "";
  if (digits.startsWith("00")) {
    digits = digits.slice(2);
  }
  while (digits.startsWith("371") && digits.length > 8) {
    digits = digits.slice(3);
  }
  return digits;
}

export function isValidLvNationalNumber(n) {
  return /^\d{8}$/.test(n);
}

export function toCallNumber(raw) {
  const national = normalizeLvNumber(raw);
  return national ? `371${national}` : "";
}

/** Number the TelTel keypad accepts. Agents paste the on-screen 8-digit LV number. */
export function toTeltelDialNumber(raw) {
  return normalizeLvNumber(raw);
}
